import BASE_RULE from '../baseRule';
import {SearchTypeSavedSearch} from './constants';
import {SavedSearchRule} from './types';

export const savedSearchRuleDefaults: SavedSearchRule = {
	...BASE_RULE,
	elementType: SearchTypeSavedSearch,
	elementSubType1: 4,
	elementSubType2: 0,
	elementValue1: 0,
};

export default savedSearchRuleDefaults;
